"use client"

import { Button, Select } from "@instacover/ui-web"
import { Maybe } from "@instacover/utils"
import { useState } from "react"

import { Spacer } from "@/components/Spacer"
import { devtoolsLoginAction } from "@/server/auth/devtoolsLoginAction"
import { logoutAction } from "@/server/auth/logoutAction"

type Props = {
  users: { email: Maybe<string>; id: string }[]
  onClose: () => void
}

export function DevtoolsImpersonate(props: Props) {
  const { users, onClose } = props

  const [email, setEmail] = useState("")

  return (
    <>
      <h6 className="text-sm font-semibold text-slate-800">Impersonate user</h6>

      <Spacer className="h-2" />

      <div>
        <Select.Root value={email === "" ? null : email} onValueChange={(value) => setEmail(value ?? "")}>
          <Select.Trigger>
            <Select.Value placeholder="Email" className="max-w-[280px]" />
          </Select.Trigger>

          <Select.Content>
            {users.map((user) => {
              if (!user.email) {
                return null
              }
              return (
                <Select.Item key={user.email} value={user.email}>
                  {user.email}
                </Select.Item>
              )
            })}
          </Select.Content>
        </Select.Root>

        <Spacer className="h-4" />

        <div className="flex justify-end gap-3">
          <Button
            size="sm"
            onClick={async () => {
              try {
                await logoutAction({})
              } finally {
                onClose()
              }
            }}
          >
            Odhlásit
          </Button>

          <Button
            size="sm"
            disabled={!email}
            type="button"
            onClick={async () => {
              try {
                await devtoolsLoginAction({ email })
              } finally {
                onClose()
              }
            }}
          >
            Login
          </Button>
        </div>
      </div>
    </>
  )
}
